import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router, Route } from '@angular/router';
import { Marketplace } from 'app/infrastructure/model/classes/marketplace.class';
import { MarketplaceService, MARKETPLACE_ITEMTYPE_AllOfThem, MARKETPLACE_ITEMTYPE_StandardFlow } from 'app/infrastructure/services/marketplace.service';
import { ProductFlowService, ProductFlowConfig } from 'app/infrastructure/services/productFlow.service';
import { SxDocumentTypes } from '../sxfdesigner/components/main/completeContext';

@Component({
  selector: 'sx-product-standard-flow-list',
  templateUrl: './productStandardFlowList.component.html',
  styleUrls: ['./productStandardFlowList.component.scss'],
})
export class ProductStandardFlowListComponent implements OnInit {
  public searchPage: string;
  public searchInteractionRule: string;

  codOrganizacion: string;
  codSistema: string;
  codNegocio: string;
  codProduct: string;
  documentKind: string;
  standardKey: string;
  preguntarSiDeseaBorrar = [];
  flowConfig: ProductFlowConfig[] = [];
  marketplaceItems: Marketplace[];
  marketplaceItemsFiltered: Marketplace[];
  subscribedFlows = [];
  showImport = false;
  cardExpandedId: any;
  expand: boolean;


  constructor(private productFlowService: ProductFlowService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private marketplaceService: MarketplaceService) {}

  ngOnInit() {

    this.aRoute.params.subscribe((params: Params) => {
      this.codOrganizacion = params ['codorganizacion'];
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProduct = params['codproducto'];
      this.documentKind = params['documentKind'];
      
      if (this.codSistema === undefined) {
        this.codSistema = 'null';
      }
      if (this.codNegocio === undefined) {
        this.codNegocio = 'null';
      }
      if (this.codProduct === undefined) {
        this.codProduct = 'null';
      }
      if (this.documentKind === undefined) {
        this.documentKind = SxDocumentTypes.None;
      }

      // this.productFlowService.getStandardProductFlowsForUnbinded(this.codSistema, this.codNegocio, this.codProduct, this.documentKind,this.standardKey).subscribe(
      //   x => { 
      //     this.flowConfig = x; 
      //   });

        this.marketplaceService
        .getMarketplaces([MARKETPLACE_ITEMTYPE_AllOfThem],[this.codOrganizacion])
        .subscribe((response) => (
          this.marketplaceItems = response.filter(m => m.type == MARKETPLACE_ITEMTYPE_StandardFlow),
          this.marketplaceItemsFiltered = this.marketplaceItems
          ));
    });
  }

  updateSubscription(flowCode : String){
  var exists = this.checkSubscription(flowCode);
    if(exists === false)
     this.subscribedFlows.push(flowCode)
    else
      this.subscribedFlows = this.subscribedFlows.filter( x=> x != flowCode);
  }

  checkSubscription(flowCode : String){
    var element = this.subscribedFlows.find( x => x === flowCode);
    if(element == null)
      return false;
    else
      return true;
  }

  goBack(){
    this.router.navigate(['../'], { relativeTo: this.aRoute });
  }

  isExpanded(event){
    this.cardExpandedId = event.id;
    this.expand = event.expand;
  }

  filtersEvent(filters: any) {
    const search = filters.search;
    const types = filters.types;

    if(types.length > 0 && search !== ''){
      this.marketplaceItemsFiltered = this.marketplaceItems.filter(
        (item) => (item.description.toLowerCase().includes(search.toLowerCase()) ||
        item.type.toLowerCase().includes(search.toLowerCase())) && 
        types.includes(item.type)
      );
    }
    else if(types.length > 0){
      this.marketplaceItemsFiltered = this.marketplaceItems.filter((item) => types.includes(item.type));
    }
    else if(search !== ''){
      this.marketplaceItemsFiltered = this.marketplaceItems.filter(
        (item) => item.description.toLowerCase().includes(search.toLowerCase()) ||
        item.type.toLowerCase().includes(search.toLowerCase())
      );
    }
    else {
      this.marketplaceItemsFiltered = this.marketplaceItems;
    }
  }

  subscriptionEvent(model: any){
    // this.productFlowService.subscribeStandardProductFlow(this.codSistema, this.codNegocio, 
    //                                                      this.codProduct, this.documentKind, 
    //                                                      this.standardKey, [model.code])
    // .then( x=> this.router.navigate(['../'], { relativeTo: this.aRoute }))
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/dynamicFlow/productStandardFlowList.component.ts